export interface InfractionRanking {
  _id: string;
  name: string;
  total: number;
  journeys_count: number;
  average: number;
  ranking: number;
}

export interface InfractionSummarized {
  type: InfractionTypes;
  average: number;
  total: number;
}

export interface InfractionConsolidated {
  reference_month: string,
  competence_start: string,
  competence_end: string,
  days: {
    [key: string]: any[]
  },
  user: {
    _id: string,
    name: string
  },
  totals: {
    all: number,
    manual_macro: number,
    altered_macro: number,
    meal_time: number,
    interjourney_time: number,
    long_working_time: number,
    extra_hour: number
  }
}

export enum InfractionConsolidatedTotalsEnum {
  all = 'all',
  manual_macro = 'manual_macro',
  altered_macro = 'altered_macro',
  meal_time = 'meal_time',
  interjourney_time = 'interjourney_time',
  long_working_time = 'long_working_time',
  extra_hour = 'extra_hour'
}

export interface InfractionRankingFilter {
  payroll_group_id?: string;
  section_id?: string;
  infraction_types?: string[];
  start_date: string;
  end_date: string;
  reference_month: string;
  sort_key?: string;
  sort_value?: string;
}

export enum InfractionGranularity {
  day = 'day',
  month = 'month'
}

export enum InfractionTypes {
  MANUAL_MACRO = 'MANUAL_MACRO',
  ALTERED_MACRO = 'ALTERED_MACRO',
  EXTRA_HOUR = 'EXTRA_HOUR',
  MEAL_TIME = 'MEAL_TIME',
  INTERJOURNEY_TIME = 'INTERJOURNEY_TIME',
  LONG_WORKING_TIME = 'LONG_WORKING_TIME'
}

export interface InfractionState {
  infraction: {
    infractionRankingList: {
      data: InfractionRanking[];
      currentPage: number;
      totalItems: number;
      totalPages: number;
      limitPerPage: number;
      offset: number;
      filters: InfractionRankingFilter;
      setLimitPerPage: (limitPerPage: number) => void;
      setCurrentPage: (page: number) => void;
      setFilters: (filters: InfractionRankingFilter) => void;
    };
    selectedDateType: string;
    infractionsSummarized: InfractionSummarized[];
    infractionsTypePerPeriodChartData: any[];
    infractionsTypePerPeriodUserChartData: any[];
    infractionsTypeSparklinesChartData: any[];
    setSelectedDateType: (dateType: string) => void;
    visibleInfractionTypes: string[];
    setVisibleInfractionTypes: (infractionTypes: string[]) => void;
    infractionConsolidatedSelected: InfractionConsolidated | null,
    isLoadingInfractionRankingList: boolean;
    isLoadingInfractionConsolidated: boolean;
    isLoadingInfractionSummarized: boolean;
    isLoadingInfractionsTypePerPeriodChartData: boolean;
    isLoadingInfractionsTypePerPeriodUserChartData: boolean;
    getInfractionRanking: () => void;
    getInfractionConsolidated: (userId: string, referenceDate: string) => void;
    getInfractionSummarized: () => void;
    getInfractionTypePerPeriodChartData: (userId?: string) => void;
  }
}